<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :inputs="inputs"
    :is-form-fetched="isFetched"
    :module-enabler="moduleEnabler"
    :has-buttons="false"
  >
    <template #[`treeviews.input`]>
      <v-row no-gutters>
        <v-col cols="12">
          <treeviews-settings-list />
        </v-col>
      </v-row>
    </template>
  </admin-wrapper>
</template>
<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import TreeviewsSettingsList from '@/components/TreeviewsSettingsList';

export default {
  name: 'TreeviewsSettings',
  components: { AdminWrapper, TreeviewsSettingsList },
  computed: {
    additionalModuleName: get('admin/additionalModules@TREE_VIEW.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@tree_view_module_enabled'),
    inputs() {
      return [
        {
          name: 'treeviews',
          isNamedSlot: false,
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'tree_view_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle2', { suffix: this.additionalModuleName }),
      };
    },
  },
  data: () => ({
    isFetched: false,
  }),
  methods: {
    getDataSources: call('layers/getLayersMetadata'),
    getLayers: call('layers/getLayers'),
    getTreeviews: call('attributesSchema/getTreeviews'),
    async init() {
      await Promise.all([this.getDataSources({ with_attributes_schema: true }), this.getLayers(), this.getTreeviews()]);
      this.isFetched = true;
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFetched = true;
    }
  },
};
</script>
